import React from "react";
import { TrendingUp } from "lucide-react";

function fmt(n, d = 1) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return Number(n).toFixed(d);
}

export default function MaxDemandCard({ stats }) {
  if (!stats) {
    return (
      <section className="panel p-5" data-testid="max-demand">
        <div className="label-tech">Loading…</div>
      </section>
    );
  }
  const rows = [
    ["MAX kVA", fmt(stats.max_kva), "kVA"],
    ["MAX kW", fmt(stats.max_kw), "kW"],
    ["AVG PF", fmt(stats.avg_pf, 3), ""],
    ["MAX I1", fmt(stats.max_i1), "A"],
    ["MAX I2", fmt(stats.max_i2), "A"],
    ["MAX I3", fmt(stats.max_i3), "A"],
    ["MAX V12", fmt(stats.max_v12, 0), "V"],
    ["MAX V23", fmt(stats.max_v23, 0), "V"],
    ["MAX V31", fmt(stats.max_v31, 0), "V"],
  ];
  return (
    <section className="panel p-5" data-testid="max-demand">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base tracking-tight">MAX DEMAND</h3>
        <TrendingUp className="w-4 h-4 text-zinc-500" strokeWidth={1.5} />
      </div>
      <div className="grid grid-cols-3 gap-px bg-white/10 border border-white/10 rounded-lg overflow-hidden">
        {rows.map(([k, v, u]) => (
          <div key={k} className="bg-white/[0.03] backdrop-blur-md p-3">
            <div className="label-tech text-[9px]">{k}</div>
            <div className="font-mono-tech text-sm mt-1">
              {v}<span className="label-tech ml-1">{u}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="label-tech mt-4">SAMPLES: {stats.sample_count ?? 0}</div>
    </section>
  );
}
